// -------------------------------------------------
// スクロール禁止（iOS 実機対応）
// -------------------------------------------------
let scrollTop = 0;
let touchStartY = 0;
let touchMoveHandler = null;
let touchStartHandler = null;
let scrollHandler = null;

const SCROLLABLE_SELECTOR = '.c-header__drawer-scroll, .c-modal, .js-modal-container';

function getScrollTop() {
  return window.pageYOffset
    || document.documentElement.scrollTop
    || document.body.scrollTop
    || 0;
}

function getScrollableTarget(target) {
  return target.closest(SCROLLABLE_SELECTOR);
}

function canScrollElement(el, deltaY) {
  if (!el || el.scrollHeight <= el.clientHeight) return false;

  const { scrollTop, scrollHeight, clientHeight } = el;
  const isAtTop = scrollTop <= 0;
  const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1;

  if (deltaY > 0 && isAtTop) return false;
  if (deltaY < 0 && isAtBottom) return false;

  return true;
}

function onTouchStart(e) {
  touchStartY = e.touches[0].clientY;
}

function onTouchMove(e) {
  const currentY = e.touches[0].clientY;
  const deltaY = currentY - touchStartY;
  const scrollable = getScrollableTarget(e.target);

  if (canScrollElement(scrollable, deltaY)) return;

  e.preventDefault();
}

function onScrollLock() {
  window.scrollTo(0, scrollTop);
}

function scrollBanOpen() {
  const html = document.documentElement;
  const body = document.body;
  if (html.classList.contains('is-hidden')) return;

  scrollTop = getScrollTop();

  body.style.position = 'fixed';
  body.style.top = `${scrollTop * -1}px`;
  body.style.left = '0';
  body.style.right = '0';
  body.style.width = '100%';
  body.style.overflow = 'hidden';
  body.style.touchAction = 'none';

  html.classList.add('is-hidden');
  html.style.overflow = 'hidden';
  $('html').css({ 'scroll-behavior': 'auto' });

  touchStartHandler = onTouchStart;
  touchMoveHandler = onTouchMove;
  scrollHandler = onScrollLock;

  document.addEventListener('touchstart', touchStartHandler, { passive: true });
  document.addEventListener('touchmove', touchMoveHandler, { passive: false });
  window.addEventListener('scroll', scrollHandler, { passive: true });
}

function scrollBanClose() {
  const html = document.documentElement;
  const body = document.body;
  if (!html.classList.contains('is-hidden')) return;

  if (touchStartHandler) {
    document.removeEventListener('touchstart', touchStartHandler);
    touchStartHandler = null;
  }

  if (touchMoveHandler) {
    document.removeEventListener('touchmove', touchMoveHandler);
    touchMoveHandler = null;
  }

  if (scrollHandler) {
    window.removeEventListener('scroll', scrollHandler);
    scrollHandler = null;
  }

  body.style.position = '';
  body.style.top = '';
  body.style.left = '';
  body.style.right = '';
  body.style.width = '';
  body.style.overflow = '';
  body.style.touchAction = '';

  html.classList.remove('is-hidden');
  html.style.overflow = '';
  html.style.scrollBehavior = 'auto';
  $('html').css({ 'scroll-behavior': 'auto' });

  window.scrollTo({ top: scrollTop, left: 0, behavior: 'auto' });
  document.documentElement.scrollTop = scrollTop;
  document.body.scrollTop = scrollTop;
}

function scrollBan() {
  if (document.documentElement.classList.contains('is-hidden')) {
    scrollBanClose();
  } else {
    scrollBanOpen();
  }
}

window.scrollBanOpen = scrollBanOpen;
window.scrollBanClose = scrollBanClose;
window.scrollBan = scrollBan;
